import EventsSitePreview from '@Components/TicketedEvents/EventsSitePreview';
import { useEventPreviewStore } from '../../../stores/eventPreviewStore';

export default function TicketedEventPreview() {
  const previewData = useEventPreviewStore((s) => s.previewData);

  if (!previewData) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-zinc-500">
          No preview data available. Open this page from an event preview.
        </p>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-auto">
      <EventsSitePreview
        event={previewData.event}
        venue={previewData.venue}
        fullPage
      />
    </div>
  );
}
